import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/GlobalContext";
import ResumeDetails from "./ResumeDetails";

function Resume() {
    
    const {lang, resume, showElement} = useContext(GlobalContext)

    return(
        <div className="resume">
            <h3 className="resume__title">{lang === "ingles" ? "Resume" : "Curriculum"}</h3>

            <div className="resume__categorys">
                {resume.map((cat) =>{
                    console.log(cat.items);
                    return(
                        <div className="resume__element">
                            <h5 className="resume__subtitle listItem" id={"sub" + cat.id.split(' ').join('')} onClick={() => showElement(cat.id)}>{cat.id}  +</h5>
                            <div id={cat.id.split(' ').join('')} className="resume__details listDetail">
                                {cat.items.length !== 0
                                ?
                                    <ResumeDetails
                                        object = {cat.items}
                                    />
                                :
                                null
                                }
                            </div>
                        </div>
                    )
                })}
            </div>    

        </div>
    )
}

export default Resume